import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { Channel } from '~core/models/channel.models';

@Component({
  selector: 'channel-details',
  standalone: false,
  templateUrl: './channel-details.component.html',
  styleUrl: './channel-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChannelDetailsComponent extends BaseComponent {
  channels = input<Channel>();
}
